import axios from "../axiosApi";
import { FETCH_CLASS_OFFERS, RECEIVE_CLASS_OFFERS, SAVE_CLASS_OFFER, SAVE_CLASS_OFFER_SUCCESS, DELETE_CLASS_OFFER, DELETE_CLASS_OFFER_SUCCESS } from "../actionTypes";

export const getClassOffers = () => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_CLASS_OFFERS });
        try {
            const filter = JSON.stringify({ "include": ["level"] });
            const response = await axios.get(`/ClassOffers?filter=${filter}`);
            dispatch({ type: RECEIVE_CLASS_OFFERS, payload: response.data });
        } catch (e) {
            console.error("getClassOffers ERROR", e);
            dispatch({ type: RECEIVE_CLASS_OFFERS, payload: [] });
        }
    }
}

export const saveClassOffer = (data: any) => {
    return async (dispatch: any) => {
        dispatch({ type: SAVE_CLASS_OFFER });
        try {
            let response;
            if (data.id) {
                const id = data.id;
                delete data.id;
                response = await axios.put(`/ClassOffers/${id}`, data);
            } else {
                if (data.id === null) delete data.id;
                response = await axios.post('/ClassOffers', data);
            }
            dispatch({ type: SAVE_CLASS_OFFER_SUCCESS, payload: response.data });
            dispatch(getClassOffers());
        } catch (e) {
            console.error("saveClassOffer ERROR", e);
            dispatch({ type: SAVE_CLASS_OFFER_SUCCESS, payload: { error: true } });
        }
    }
}

export const deleteClassOffer = (id: number) => {
    return async (dispatch: any) => {
        dispatch({ type: DELETE_CLASS_OFFER });
        try {
            await axios.delete(`/ClassOffers/${id}`);
            dispatch({ type: DELETE_CLASS_OFFER_SUCCESS });
            dispatch(getClassOffers());
        } catch (e) {
            console.error("deleteClassOffer ERROR", e);
        }
    }
}
